module.exports = __webpack_public_path__ + "static/media/CAT_COMPATIBLE.dcccba32.svg";